import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const StickyNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const navLinks = [
    { label: 'Zo werkt het', id: 'zo-werkt-het' },
    { label: 'Batterijen', id: 'productkeuze' },
    { label: 'Vergelijking', id: 'vergelijking' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-elevation-2' : 'bg-white/95 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/homepage" className="flex items-center space-x-2 flex-shrink-0">
              <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                <Icon name="Leaf" size={18} color="white" />
              </div>
              <span className="font-heading font-semibold text-base text-foreground hidden sm:block">
                Verduurzaamwijzer<span className="text-primary">.nu</span>
              </span>
            </Link>

            {/* Desktop anchor links */}
            <div className="hidden md:flex items-center space-x-6">
              {navLinks?.map((link) => (
                <button
                  key={link?.id}
                  onClick={() => scrollTo(link?.id)}
                  className="text-sm font-body text-muted-foreground hover:text-primary transition-colors"
                >
                  {link?.label}
                </button>
              ))}
            </div>

            {/* CTA */}
            <div className="flex items-center space-x-3">
              <button
                onClick={() => scrollTo('formulier')}
                className="hidden sm:inline-flex items-center px-4 py-2 bg-primary text-primary-foreground text-sm font-heading font-semibold rounded-md hover:bg-primary/90 transition-colors"
              >
                Gratis adviesgesprek
              </button>
              <button
                className="md:hidden p-2 text-foreground"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Menu openen"
              >
                <Icon name={mobileOpen ? 'X' : 'Menu'} size={22} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-border px-4 py-4 space-y-3">
            {navLinks?.map((link) => (
              <button
                key={link?.id}
                onClick={() => scrollTo(link?.id)}
                className="block w-full text-left text-sm font-body text-foreground py-2 border-b border-border/50"
              >
                {link?.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo('formulier')}
              className="w-full mt-2 px-4 py-3 bg-primary text-primary-foreground text-sm font-heading font-semibold rounded-md"
            >
              Gratis adviesgesprek
            </button>
          </div>
        )}
      </nav>
      {/* Mobile sticky CTA bar at bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-50 sm:hidden bg-primary px-4 py-3 shadow-elevation-3">
        <button
          onClick={() => scrollTo('formulier')}
          className="w-full text-center text-sm font-heading font-semibold text-primary-foreground"
        >
          Gratis adviesgesprek plannen →
        </button>
      </div>
    </>
  );
};

export default StickyNav;
